module.exports = __webpack_public_path__ + "f957155e027c41d5fa80b2aef856145f.jpg";